// Layout Types
import DefaultLayout from './layouts/DefaulLayout'
import PlayerLayout from './layouts/PlayerLayout'

// Route Views
import TermsConditions from './pages/TermsConditions'
import Editor from './pages/Editor'
import Home from './pages/Home'
import LiveVideo from './pages/LiveVideo'
import News from './pages/News'
import NotFound from './pages/NotFound'
import Podcast from './pages/Podcast'
import PodcastByCategory from './pages/PodcastByCategory'
import PodcastProgram from './pages/PodcastProgram'
import PrivacyAgreement from './pages/PrivacyAgreement'
import RadioByCategory from './pages/RadioByCategory'
import RadioProgram from './pages/RadioProgram'
import Read from './pages/Read'
import Search from './pages/Search'
import Top from './pages/Top'
/* import TopsFeed from './pages/TopsFeed' */
import Watch from './pages/Watch'
import Player from './components/core/Player'
import MinimalPlayer from './components/core/MinimalPlayer'

// Configurations
import { radioSections } from './config/radioCategories'
import {
  urlPublicNames
} from './config/stations'

const radioCategories = radioSections.radio.categories.alias
const podcastCategories = radioSections.podcast.categories.alias
const _stations = Object.keys(urlPublicNames)

export const routes = [
  {
    path: '/',
    exact: true,
    layout: DefaultLayout,
    component: Home
  },
  {
    path: '/editor/:hashid([0-9]{1,10}_[a-zA-Z0-9-]{1,300})/:page([0-9]{1,10})',
    exact: true,
    layout: DefaultLayout,
    component: Editor
  },
  {
    path: '/live-video',
    exact: true,
    layout: DefaultLayout,
    component: LiveVideo
  },
  {
    path: '/news/:page([0-9]{1,10})/:tag?',
    exact: true,
    layout: DefaultLayout,
    component: News
  },
  {
    path: '/404',
    exact: true,
    layout: DefaultLayout,
    component: NotFound
  },
  {
    path: '/acuerdo-de-privacidad',
    exact: true,
    layout: DefaultLayout,
    component: PrivacyAgreement
  },
  {
    path: '/podcast/explorar',
    exact: true,
    layout: DefaultLayout,
    component: Podcast
  },
  {
    path: `/podcast/:category(${podcastCategories.join('|')}!explorar)`,
    exact: true,
    layout: DefaultLayout,
    component: PodcastByCategory
  },
  {
    path: '/podcast/:hashid([0-9]{1,10}_[a-zA-Z0-9-]{1,300})/:page([0-9]{1,10})?',
    exact: true,
    layout: DefaultLayout,
    component: PodcastProgram
  },
  {
    path: `/:category(${radioCategories.join('|')})/explorar`,
    exact: true,
    layout: DefaultLayout,
    component: RadioByCategory
  },
  {
    path: `/:category(${radioCategories.join('|')}|)/:hashid([0-9]{1,10}_[a-zA-Z0-9-]{1,300})/:page([0-9]{1,10})?`,
    exact: true,
    layout: DefaultLayout,
    component: RadioProgram
  },
  {
    path: '/leer/:hashid([0-9]{1,10}_[a-zA-Z0-9-]{1,300})',
    exact: true,
    layout: DefaultLayout,
    component: Read
  },
  {
    path: '/busqueda/:page',
    layout: DefaultLayout,
    exact: true,
    component: Search
  },
  {
    path: '/terminos-y-condiciones',
    exact: true,
    layout: DefaultLayout,
    component: TermsConditions
  },
  /* {
    path: '/top/:hashid([0-9]{1,10}_[a-zA-Z0-9-]{1,300})',
    layout: DefaultLayout,
    exact: true,
    component: Top
  },
  {
    path: '/tops/:page([0-9]{1,10})',
    layout: DefaultLayout,
    exact: true,
    component: TopsFeed
  },
  */
  {
    path: '/ver/:hashid([0-9]{1,10}_[a-zA-Z0-9-]{1,300})',
    layout: DefaultLayout,
    exact: true,
    component: Watch
  },
  {
    path: '/escuchar',
    layout: PlayerLayout,
    exact: true,
    component: Player
  },
  {
    path: `/:station(${_stations.join('|')})`,
    layout: PlayerLayout,
    exact: true,
    component: MinimalPlayer
  }
]
